module.exports = __webpack_public_path__ + "img/krabby_patty.b5ee4849.jpg";